module.exports = __webpack_public_path__ + "static/media/icon-trash.e2cf6794.svg";